/*
 * This is the Global JS file.
 * There should be minimal changes needed to this file,
 * however if some global logic must be set-up it can be done here.
 */

import Layout from './layout';
import Video from './video';

export default () => {
  const uniq = (value, index, self) => self.indexOf(value) === index;
  const sections = document.querySelectorAll('[data-section]');
  const sectionNames = [...sections]
    .map((section) => section.dataset.section)
    .filter(uniq);
  const layout = Layout.getInstance();
  const moduleList = {};

  const passwordToggles = document.querySelectorAll('.password-toggle');

  passwordToggles.forEach((toggle) => {
    toggle.addEventListener('click', (e) => {
      e.preventDefault();
      const currentIcon = toggle.querySelector('svg:not(.hidden)');
      const toggleIcon = toggle.querySelector('svg.hidden');
      currentIcon.classList.add('hidden');
      toggleIcon.classList.remove('hidden');
      const passwordInput = toggle.parentNode.querySelector('input');
      // eslint-disable-next-line no-unused-expressions
      passwordInput.type === 'password'
        ? (passwordInput.type = 'text')
        : (passwordInput.type = 'password');
    });
  });

  const unsetScroll = () => {
    sessionStorage.removeItem('tmwScrollPosition');
  };

  document.addEventListener('click', (event) => {
    const target = event.target.closest('a');
    if (
      target &&
      target.href.includes('/collections/') &&
      !target.href.includes('products/')
    ) {
      unsetScroll();
    }
  });

  if (window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', (e) => {
      const { sectionId } = e.detail;
      const el = e.target.querySelector('[data-section]');
      // eslint-disable-next-line no-console
      console.log('moduleList', moduleList);
      (moduleList[sectionId]
        ? Promise.resolve(moduleList[sectionId].m)
        : import(
            /* webpackChunkName: "[index]" */
            `../${el.dataset.section}/index.js`
          )
      ).then((m) => {
        const dataEl = el.querySelector('[data-section-data]');
        const data = dataEl ? JSON.parse(dataEl.textContent) : {};
        const videoEls = el.querySelectorAll('[data-component="video"]');
        const videos =
          videoEls &&
          [...videoEls].map(
            (videoEl) => new Video({ el, video: videoEl, layout }),
          );
        m?.default(el, { ...data, layout, videos });
      });
    });
  }

  sectionNames.forEach((name) => {
    import(/* webpackChunkName: "[index]" */ `../${name}/index.js`)
      .then((m) => {
        const module = m.default;
        const modules = [...sections].filter(
          (section) => section.dataset.section === name,
        );
        modules.forEach((element) => {
          const dataEl = element.querySelector('[data-section-data]');
          const data = dataEl ? JSON.parse(dataEl.textContent) : {};
          const videoEls = element.querySelectorAll('[data-component="video"]');
          const videos =
            videoEls &&
            [...videoEls].map(
              (videoEl) => {
                const videoContainerEl = videoEl.querySelector('.video-container');
                const videoId = videoContainerEl?.id;
                return new Video({ 
                  element, 
                  video: videoEl, 
                  videoId, 
                  layout 
                });
              }
            );
          module(element, { ...data, layout, videos });
        });
      })
      // eslint-disable-next-line no-console
      .catch(console.error);
  });
};
